import { DropdownArrowIcon } from '@kaiizen/kai-shiki/react';

/**
 * Unified size for inline expand/collapse carets (accordions, dropdown triggers,
 * task-detail headers) so every affordance renders at one consistent size and
 * glyph. Uses the same DropdownArrowIcon language as the sidebar show/hide toggle.
 */
const EXPAND_CARET_ICON_SIZE = 12;

export const ExpandCaret = (
  { expanded, color, initialRotation = 0, finalRotation = 90 }: { expanded?: boolean; color?: string; initialRotation?: number; finalRotation?: number },
) => (
  <DropdownArrowIcon
    color={color}
    size={EXPAND_CARET_ICON_SIZE}
    style={{ transform: `rotate(${initialRotation + (expanded ? finalRotation : 0)}deg)`, transition: 'transform 120ms ease' }}
    aria-hidden={'true'}
    data-closeout-expand-caret={'true'}
  />
);

/**
 * Two chevrons where `ExpandCaret` draws one: the same affordance for a step that covers more ground.
 *
 * Drawn in `DropdownArrowIcon`'s own 24x24 box at the same 16px, so a single and a double caret occupy
 * exactly the same width — a column of them keeps one left edge for whatever follows.
 */
export const DoubleExpandCaret = ({ color = 'currentColor' }: { color?: string }) => (
  <svg
    width={EXPAND_CARET_ICON_SIZE}
    height={EXPAND_CARET_ICON_SIZE}
    viewBox={'0 0 24 24'}
    fill={'none'}
    aria-hidden={'true'}
    data-closeout-expand-caret={'double'}
  >
    <path d={'M4 6L11 12.5L4 19'} stroke={color} strokeMiterlimit={'10'} />
    <path d={'M12 6L19 12.5L12 19'} stroke={color} strokeMiterlimit={'10'} />
  </svg>
);
